var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { connect } from 'react-redux';
import * as SearchFactory from '../../classes/definitions/search/search';
import ApiRequests from '../../classes/http/ApiRequests';
import HttpRequests from '../../classes/http/HttpRequests';
import SearchList from '../../components/Search/SearchList/SearchList';
import AppRoutes from '../../config/appRoutes';
import SearchReduxProps from './SearchReduxProps';
var Searches = /** @class */ (function (_super) {
    __extends(Searches, _super);
    function Searches() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.queryParams = { pageNumber: 1, filter: '' };
        _this.state = {
            data: [],
            meta: null,
            delaySearchTimer: null,
        };
        _this.getSearches = function (pageNum) {
            _this.api
                .getSearches()
                .then(function (response) {
                var searches = SearchFactory.createSearches(response.data.data);
                var meta = _.get(response, 'data.meta', null);
                _this.setState({ data: searches, meta: meta });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с продукти', _this.props.history);
            });
        };
        _this.toNewSearch = function () {
            _this.props.history.push(AppRoutes.search.path);
        };
        _this.search = function (event) {
            clearTimeout(_this.state.delaySearchTimer);
            var searchVal = event.target.value;
            if (searchVal) {
                _this.setState({
                    delaySearchTimer: setTimeout(function () {
                        _this.api
                            .searchBarcode(searchVal)
                            .then(function (response) {
                            var searches = SearchFactory.createSearches(response.data.data);
                            _this.setState({ data: searches });
                        })
                            .catch(function (error) {
                            _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с търсенията', _this.props.history);
                        });
                    }, 1000),
                });
                return;
            }
            _this.getSearches(1);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    Searches.prototype.componentDidMount = function () {
        this.getSearches(1);
    };
    Searches.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn searchesClass" },
                React.createElement("h1", { className: "display-3" }, "\u0422\u044A\u0440\u0441\u0435\u043D\u0435"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewSearch, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432\u043E \u0422\u044A\u0440\u0441\u0435\u043D\u0435")),
                        React.createElement(Messages, { ref: function (el) {
                                _this.messages = el;
                            } }),
                        React.createElement(SearchList, { gridData: data, meta: meta, getAllSearches: this.getSearches, search: this.search, messages: this.messages, deleteItem: this.deleteItem }))))));
    };
    return Searches;
}(React.Component));
export default connect(null, SearchReduxProps.mapDispatchToProps)(Searches);



//////////////////
// WEBPACK FOOTER
// ./src/views/Searches/Searches.tsx
// module id = 457
// module chunks = 0